import { customerTypeList } from '@/common/demand'

/**
 * 用户类型转换
 * @param {Number|String} type 用户类型
 */
export default function parseCustomerType(type) {
  const customer = customerTypeList.filter(item => (
    Number(item.id) === Number(type)
  ))
  if (customer.length > 0) return customer[0].name
  return '-'
}
